import React, { useState, useEffect } from 'react';
import ImageApi from '../../../api/image';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const WorshipLocationItem = ({ id, title, imageData, description, religion }) => {
  const [image, setImage] = useState('');

  useEffect(() => {
    if (imageData && imageData.thumbnailUrl) {
      ImageApi.getImage(imageData.thumbnailUrl).then((imageUrl) => {
        setImage(imageUrl);
      });
    }
  }, []);

  return (
    <Link to={`/worship-locations/${id}`} className="worship-locations-container-item">
      <div className="worship-locations-container-hub-list-upper">
        {image ? (
          <img
            className="worship-locations-container-hub-list-image"
            src={image}
            alt="community-thumbnail"
          />
        ) : null}
        <div className="worship-locations-container-hub-list-content">
          <p className="worship-locations-container-hub-list-title">{title}</p>
          <p className="worship-locations-container-hub-list-title" style={{ color: '#F6911E' }}>
            {religion}
          </p>
          <p className="worship-locations-container-hub-list-description">{description}</p>
        </div>
        <FontAwesomeIcon
          icon={['fas', 'chevron-right']}
          className="worship-locations-back-link-icon"
        />
      </div>
    </Link>
  );
};

export default WorshipLocationItem;
